import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/$tenant/billing` n'a pas d'écran à lui : il ouvre les factures (lot L01). */
export const Route = createFileRoute('/$tenant/billing/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$tenant/billing/invoices', params: { tenant: params.tenant } });
  },
});
